export default __webpack_public_path__ + "static/lessons-895cec28a3708fbb58e6a3b46bedac3e.mp4";